import React from 'react';
export function ColorPalettePage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: '#111111'
  }} data-id="element-13">
      <div className="max-w-6xl mx-auto px-6 py-16" data-id="element-14">
        {/* Header */}
        <div className="mb-12" data-id="element-15">
          <h1 className="text-5xl font-bold text-white mb-2 tracking-tight" data-id="element-16">
            Golden Mountain Sunrise
          </h1>
          <p style={{
          color: '#888888'
        }} className="text-base" data-id="element-17">
            Spalvų Paletės — 23 variantų
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-18">
          {/* 1. Classic Alpine Dawn */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-19">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-20">
              1. Classic Alpine Dawn
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-21">
              Švelnus, tradicinis saulėtekis
            </p>
            <div className="flex gap-3" data-id="element-22">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-23">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#1A1A2E',
                height: '72px'
              }} data-id="element-24" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-25">
                  #1A1A2E
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-26">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#E8C547',
                height: '72px'
              }} data-id="element-27" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-28">
                  #E8C547
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-29">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F4A261',
                height: '72px'
              }} data-id="element-30" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-31">
                  #F4A261
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-32">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#E76F51',
                height: '72px'
              }} data-id="element-33" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-34">
                  #E76F51
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-35">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#F8F4E3',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-36" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-37">
                  #F8F4E3
                </span>
              </div>
            </div>
          </div>

          {/* 2. Misty Peaks */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-38">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-39">
              2. Misty Peaks
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-40">
              Rūkuotas, poetiškas rytas
            </p>
            <div className="flex gap-3" data-id="element-41">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-42">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#2D3561',
                height: '72px'
              }} data-id="element-43" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-44">
                  #2D3561
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-45">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#A8DADC',
                height: '72px'
              }} data-id="element-46" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-47">
                  #A8DADC
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-48">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FFD166',
                height: '72px'
              }} data-id="element-49" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-50">
                  #FFD166
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-51">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F4A261',
                height: '72px'
              }} data-id="element-52" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-53">
                  #F4A261
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-54">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#EAE0D5',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-55" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-56">
                  #EAE0D5
                </span>
              </div>
            </div>
          </div>

          {/* 3. Volcanic Gold */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-57">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-58">
              3. Volcanic Gold
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-59">
              Drąsus, intensyvus, dramatiškas
            </p>
            <div className="flex gap-3" data-id="element-60">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-61">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#0D0D0D',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.12)'
              }} data-id="element-62" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-63">
                  #0D0D0D
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-64">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FF6B35',
                height: '72px'
              }} data-id="element-65" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-66">
                  #FF6B35
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-67">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FFD700',
                height: '72px'
              }} data-id="element-68" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-69">
                  #FFD700
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-70">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#C9184A',
                height: '72px'
              }} data-id="element-71" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-72">
                  #C9184A
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-73">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFF3B0',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-74" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-75">
                  #FFF3B0
                </span>
              </div>
            </div>
          </div>

          {/* 4. Soft Pastel Sunrise */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-76">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-77">
              4. Soft Pastel Sunrise
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-78">
              Švelnus, modernus, minimalus
            </p>
            <div className="flex gap-3" data-id="element-79">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-80">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFF0F3',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-81" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-82">
                  #FFF0F3
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-83">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFCCD5',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-84" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-85">
                  #FFCCD5
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-86">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FFB347',
                height: '72px'
              }} data-id="element-87" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-88">
                  #FFB347
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-89">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#C9A84C',
                height: '72px'
              }} data-id="element-90" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-91">
                  #C9A84C
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-92">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#6B4F3A',
                height: '72px'
              }} data-id="element-93" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-94">
                  #6B4F3A
                </span>
              </div>
            </div>
          </div>

          {/* 5. Nordic Fjord */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-95">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-96">
              5. Nordic Fjord
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-97">
              Šaltas + šiltas kontrastas
            </p>
            <div className="flex gap-3" data-id="element-98">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-99">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#0F3460',
                height: '72px'
              }} data-id="element-100" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-101">
                  #0F3460
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-102">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#16213E',
                height: '72px'
              }} data-id="element-103" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-104">
                  #16213E
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-105">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#E94560',
                height: '72px'
              }} data-id="element-106" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-107">
                  #E94560
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-108">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F5A623',
                height: '72px'
              }} data-id="element-109" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-110">
                  #F5A623
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-111">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FDEBD0',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-112" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-113">
                  #FDEBD0
                </span>
              </div>
            </div>
          </div>

          {/* 6. Desert Mountain */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-114">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-115">
              6. Desert Mountain
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-116">
              Žemiškas, organiškas, warm-toned
            </p>
            <div className="flex gap-3" data-id="element-117">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-118">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#3D1C02',
                height: '72px'
              }} data-id="element-119" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-120">
                  #3D1C02
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-121">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#A0522D',
                height: '72px'
              }} data-id="element-122" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-123">
                  #A0522D
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-124">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#D4A017',
                height: '72px'
              }} data-id="element-125" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-126">
                  #D4A017
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-127">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F28C28',
                height: '72px'
              }} data-id="element-128" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-129">
                  #F28C28
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-130">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FAF0E6',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-131" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-132">
                  #FAF0E6
                </span>
              </div>
            </div>
          </div>

          {/* 7. Golden Hour */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-133">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-134">
              7. Golden Hour
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-135">
              Intensyvus, saulėtas, energingas
            </p>
            <div className="flex gap-3" data-id="element-136">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-137">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#1C1C1E',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.12)'
              }} data-id="element-138" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-139">
                  #1C1C1E
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-140">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FF9500',
                height: '72px'
              }} data-id="element-141" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-142">
                  #FF9500
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-143">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FFCC02',
                height: '72px'
              }} data-id="element-144" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-145">
                  #FFCC02
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-146">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FF6B00',
                height: '72px'
              }} data-id="element-147" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-148">
                  #FF6B00
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-149">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFF8E7',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-150" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-151">
                  #FFF8E7
                </span>
              </div>
            </div>
          </div>

          {/* 8. Alpine Dusk */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-152">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-153">
              8. Alpine Dusk
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-154">
              Šiltas, rudas, jaukus
            </p>
            <div className="flex gap-3" data-id="element-155">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-156">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#2C1810',
                height: '72px'
              }} data-id="element-157" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-158">
                  #2C1810
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-159">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#8B4513',
                height: '72px'
              }} data-id="element-160" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-161">
                  #8B4513
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-162">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#D2691E',
                height: '72px'
              }} data-id="element-163" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-164">
                  #D2691E
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-165">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F4A460',
                height: '72px'
              }} data-id="element-166" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-167">
                  #F4A460
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-168">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FAEBD7',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-169" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-170">
                  #FAEBD7
                </span>
              </div>
            </div>
          </div>

          {/* 9. Crimson Summit */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-171">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-172">
              9. Crimson Summit
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-173">
              Dramatiškas, aistringas
            </p>
            <div className="flex gap-3" data-id="element-174">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-175">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#1A0A0A',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.12)'
              }} data-id="element-176" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-177">
                  #1A0A0A
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-178">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#8B0000',
                height: '72px'
              }} data-id="element-179" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-180">
                  #8B0000
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-181">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#DC143C',
                height: '72px'
              }} data-id="element-182" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-183">
                  #DC143C
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-184">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FF8C00',
                height: '72px'
              }} data-id="element-185" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-186">
                  #FF8C00
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-187">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFE4B5',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-188" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-189">
                  #FFE4B5
                </span>
              </div>
            </div>
          </div>

          {/* 10. Jade Mountain */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-190">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-191">
              10. Jade Mountain
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-192">
              Gamtiškas, gaivus kontrastas
            </p>
            <div className="flex gap-3" data-id="element-193">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-194">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#0A1628',
                height: '72px'
              }} data-id="element-195" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-196">
                  #0A1628
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-197">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#1B4332',
                height: '72px'
              }} data-id="element-198" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-199">
                  #1B4332
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-200">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#52B788',
                height: '72px'
              }} data-id="element-201" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-202">
                  #52B788
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-203">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FFD166',
                height: '72px'
              }} data-id="element-204" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-205">
                  #FFD166
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-206">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFF3CD',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-207" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-208">
                  #FFF3CD
                </span>
              </div>
            </div>
          </div>

          {/* 11. Lavender Peaks */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-209">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-210">
              11. Lavender Peaks
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-211">
              Mistiškas, violetinis saulėtekis
            </p>
            <div className="flex gap-3" data-id="element-212">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-213">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#2D1B69',
                height: '72px'
              }} data-id="element-214" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-215">
                  #2D1B69
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-216">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#7B2D8B',
                height: '72px'
              }} data-id="element-217" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-218">
                  #7B2D8B
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-219">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#E040FB',
                height: '72px'
              }} data-id="element-220" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-221">
                  #E040FB
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-222">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FFB300',
                height: '72px'
              }} data-id="element-223" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-224">
                  #FFB300
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-225">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFF9C4',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-226" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-227">
                  #FFF9C4
                </span>
              </div>
            </div>
          </div>

          {/* 12. Arctic Sunrise */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-228">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-229">
              12. Arctic Sunrise
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-230">
              Šaltas mėlynas su auksu
            </p>
            <div className="flex gap-3" data-id="element-231">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-232">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#0D1B2A',
                height: '72px'
              }} data-id="element-233" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-234">
                  #0D1B2A
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-235">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#1B4F72',
                height: '72px'
              }} data-id="element-236" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-237">
                  #1B4F72
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-238">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#5DADE2',
                height: '72px'
              }} data-id="element-239" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-240">
                  #5DADE2
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-241">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F39C12',
                height: '72px'
              }} data-id="element-242" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-243">
                  #F39C12
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-244">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FDFEFE',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-245" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-246">
                  #FDFEFE
                </span>
              </div>
            </div>
          </div>

          {/* 13. Copper Canyon */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-247">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-248">
              13. Copper Canyon
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-249">
              Vario, žemiškas, gilus
            </p>
            <div className="flex gap-3" data-id="element-250">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-251">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#1A0F00',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.12)'
              }} data-id="element-252" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-253">
                  #1A0F00
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-254">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#6B3A2A',
                height: '72px'
              }} data-id="element-255" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-256">
                  #6B3A2A
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-257">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#C0622A',
                height: '72px'
              }} data-id="element-258" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-259">
                  #C0622A
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-260">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#E8A838',
                height: '72px'
              }} data-id="element-261" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-262">
                  #E8A838
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-263">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFF5E4',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-264" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-265">
                  #FFF5E4
                </span>
              </div>
            </div>
          </div>

          {/* 14. Emerald Dawn */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-266">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-267">
              14. Emerald Dawn
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-268">
              Žalias, rytas, gaivus
            </p>
            <div className="flex gap-3" data-id="element-269">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-270">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#0A2E1A',
                height: '72px'
              }} data-id="element-271" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-272">
                  #0A2E1A
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-273">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#145A32',
                height: '72px'
              }} data-id="element-274" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-275">
                  #145A32
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-276">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#27AE60',
                height: '72px'
              }} data-id="element-277" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-278">
                  #27AE60
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-279">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F1C40F',
                height: '72px'
              }} data-id="element-280" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-281">
                  #F1C40F
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-282">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFFDE7',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-283" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-284">
                  #FFFDE7
                </span>
              </div>
            </div>
          </div>

          {/* 15. Rose Gold Summit */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-285">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-286">
              15. Rose Gold Summit
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-287">
              Rožinis auksas, romantiškas
            </p>
            <div className="flex gap-3" data-id="element-288">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-289">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#1A0A10',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.12)'
              }} data-id="element-290" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-291">
                  #1A0A10
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-292">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#6B2737',
                height: '72px'
              }} data-id="element-293" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-294">
                  #6B2737
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-295">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#C0392B',
                height: '72px'
              }} data-id="element-296" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-297">
                  #C0392B
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-298">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#E8A838',
                height: '72px'
              }} data-id="element-299" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-300">
                  #E8A838
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-301">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFF0E6',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-302" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-303">
                  #FFF0E6
                </span>
              </div>
            </div>
          </div>

          {/* 16. Coffee & Teal */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-304">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-305">
              16. Coffee &amp; Teal
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-306">
              Žemiškas + jūrinis kontrastas
            </p>
            <div className="flex gap-3" data-id="element-307">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-308">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#13070C',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.12)'
              }} data-id="element-309" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-310">
                  #13070C
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-311">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#345995',
                height: '72px'
              }} data-id="element-312" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-313">
                  #345995
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-314">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#56A3A6',
                height: '72px'
              }} data-id="element-315" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-316">
                  #56A3A6
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-317">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F3B02B',
                height: '72px'
              }} data-id="element-318" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-319">
                  #F3B02B
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-320">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F04242',
                height: '72px'
              }} data-id="element-321" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-322">
                  #F04242
                </span>
              </div>
            </div>
          </div>

          {/* 17. Gold & Midnight */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-323">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-324">
              17. Gold &amp; Midnight
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-325">
              Auksas, tamsus vandenynas, violetinė
            </p>
            <div className="flex gap-3" data-id="element-326">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-327">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFFFFF',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.15)'
              }} data-id="element-328" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-329">
                  #FFFFFF
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-330">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#ECA72C',
                height: '72px'
              }} data-id="element-331" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-332">
                  #ECA72C
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-333">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#053C5E',
                height: '72px'
              }} data-id="element-334" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-335">
                  #053C5E
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-336">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#9B5DE5',
                height: '72px'
              }} data-id="element-337" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-338">
                  #9B5DE5
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-339">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#EE4266',
                height: '72px'
              }} data-id="element-340" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-341">
                  #EE4266
                </span>
              </div>
            </div>
          </div>

          {/* 18. Bright Carnival */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-342">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-343">
              18. Bright Carnival
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-344">
              Ryškus, linksmas, energingas
            </p>
            <div className="flex gap-3" data-id="element-345">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-346">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FFFFFF',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.15)'
              }} data-id="element-347" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-348">
                  #FFFFFF
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-349">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#FECC00',
                height: '72px'
              }} data-id="element-350" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-351">
                  #FECC00
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-352">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#384199',
                height: '72px'
              }} data-id="element-353" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-354">
                  #384199
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-355">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#E460A2',
                height: '72px'
              }} data-id="element-356" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-357">
                  #E460A2
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-358">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#03A3CC',
                height: '72px'
              }} data-id="element-359" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-360">
                  #03A3CC
                </span>
              </div>
            </div>
          </div>

          {/* 19. Warm Amber Gradient */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-361">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-362">
              19. Warm Amber Gradient
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-363">
              Šiltas, gintarinis, saulėtas
            </p>
            <div className="flex gap-3" data-id="element-364">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-365">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#184A8C',
                height: '72px'
              }} data-id="element-366" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-367">
                  #184A8C
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-368">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F2B807',
                height: '72px'
              }} data-id="element-369" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-370">
                  #F2B807
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-371">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F2A20C',
                height: '72px'
              }} data-id="element-372" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-373">
                  #F2A20C
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-374">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#F28B0C',
                height: '72px'
              }} data-id="element-375" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-376">
                  #F28B0C
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-377">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#BF8665',
                height: '72px'
              }} data-id="element-378" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-379">
                  #BF8665
                </span>
              </div>
            </div>
          </div>

          {/* 20. Rose & Violet */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-380">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-381">
              20. Rose &amp; Violet
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-382">
              Rožinė + violetinė, šiuolaikiška
            </p>
            <div className="flex gap-3" data-id="element-383">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-384">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#fefefd',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.15)'
              }} data-id="element-385" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-386">
                  #fefefd
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-387">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#292c73',
                height: '72px'
              }} data-id="element-388" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-389">
                  #292c73
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-390">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#fc3367',
                height: '72px'
              }} data-id="element-391" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-392">
                  #fc3367
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-393">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#9379fe',
                height: '72px'
              }} data-id="element-394" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-395">
                  #9379fe
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-396">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#f0ecff',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-397" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-398">
                  #f0ecff
                </span>
              </div>
            </div>
          </div>

          {/* 21. Indigo Sunset */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-399">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-400">
              21. Indigo Sunset
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-401">
              Indiginis + auksas + karamelė
            </p>
            <div className="flex gap-3" data-id="element-402">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-403">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#3e4170',
                height: '72px'
              }} data-id="element-404" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-405">
                  #3e4170
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-406">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#ffbc4b',
                height: '72px'
              }} data-id="element-407" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-408">
                  #ffbc4b
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-409">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#d39979',
                height: '72px'
              }} data-id="element-410" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-411">
                  #d39979
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-412">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#6c9dc5',
                height: '72px'
              }} data-id="element-413" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-414">
                  #6c9dc5
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-415">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#fdf5e8',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-416" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-417">
                  #fdf5e8
                </span>
              </div>
            </div>
          </div>

          {/* 22. Purple Teal */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-418">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-419">
              22. Purple Teal
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-420">
              Violetinė + turkio + rožinė
            </p>
            <div className="flex gap-3" data-id="element-421">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-422">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#533b84',
                height: '72px'
              }} data-id="element-423" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-424">
                  #533b84
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-425">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#00a6de',
                height: '72px'
              }} data-id="element-426" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-427">
                  #00a6de
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-428">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#f65394',
                height: '72px'
              }} data-id="element-429" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-430">
                  #f65394
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-431">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#f9b030',
                height: '72px'
              }} data-id="element-432" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-433">
                  #f9b030
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-434">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#fff5f8',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-435" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-436">
                  #fff5f8
                </span>
              </div>
            </div>
          </div>

          {/* 23. Navy & Gold */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-437">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-438">
              23. Navy &amp; Gold
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-439">
              Tamsiai mėlynas + ryški geltona
            </p>
            <div className="flex gap-3" data-id="element-440">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-441">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#fbfffa',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.15)'
              }} data-id="element-442" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-443">
                  #fbfffa
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-444">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#002478',
                height: '72px'
              }} data-id="element-445" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-446">
                  #002478
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-447">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#29509e',
                height: '72px'
              }} data-id="element-448" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-449">
                  #29509e
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-450">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#fbc617',
                height: '72px'
              }} data-id="element-451" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-452">
                  #fbc617
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-453">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#f0f4ff',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-454" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-455">
                  #f0f4ff
                </span>
              </div>
            </div>
          </div>

          {/* 24. Silver & Crimson */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-456">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-457">
              24. Silver &amp; Crimson
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-458">
              Sidabrinė + tamsiai raudona + auksas
            </p>
            <div className="flex gap-3" data-id="element-459">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-460">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#f5f5f5',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-461" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-462">
                  #f5f5f5
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-463">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#323f69',
                height: '72px'
              }} data-id="element-464" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-465">
                  #323f69
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-466">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#bf294c',
                height: '72px'
              }} data-id="element-467" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-468">
                  #bf294c
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-469">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#e2ab05',
                height: '72px'
              }} data-id="element-470" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-471">
                  #e2ab05
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-472">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#dcdfdf',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-473" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-474">
                  #dcdfdf
                </span>
              </div>
            </div>
          </div>

          {/* 25. Steel & Amber */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-475">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-476">
              25. Steel &amp; Amber
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-477">
              Pilka + gintaras + tamsiai mėlyna
            </p>
            <div className="flex gap-3" data-id="element-478">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-479">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#F6F6F7',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-480" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-481">
                  #F6F6F7
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-482">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#A7AAA1',
                height: '72px'
              }} data-id="element-483" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-484">
                  #A7AAA1
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-485">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#DB813B',
                height: '72px'
              }} data-id="element-486" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-487">
                  #DB813B
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-488">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#EC8627',
                height: '72px'
              }} data-id="element-489" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-490">
                  #EC8627
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-491">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#282C3D',
                height: '72px'
              }} data-id="element-492" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-493">
                  #282C3D
                </span>
              </div>
            </div>
          </div>

          {/* 26. Warm Earth */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-494">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-495">
              26. Warm Earth
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-496">
              Kreminė + persikų + smėlio + tamsiai violetinė
            </p>
            <div className="flex gap-3" data-id="element-497">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-498">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#F5F6E2',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-499" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-500">
                  #F5F6E2
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-501">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#EF9E54',
                height: '72px'
              }} data-id="element-502" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-503">
                  #EF9E54
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-504">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#BFB19E',
                height: '72px'
              }} data-id="element-505" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-506">
                  #BFB19E
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-507">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#654647',
                height: '72px'
              }} data-id="element-508" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-509">
                  #654647
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-510">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#262257',
                height: '72px'
              }} data-id="element-511" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-512">
                  #262257
                </span>
              </div>
            </div>
          </div>

          {/* 27. Sunset Rose */}
          <div className="rounded-2xl p-6 border" style={{
          backgroundColor: '#1E1E1E',
          borderColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-513">
            <h2 className="text-lg font-bold text-white mb-1" data-id="element-514">
              27. Sunset Rose
            </h2>
            <p className="text-sm mb-5" style={{
            color: '#888888'
          }} data-id="element-515">
              Balta + persikų + rožinė + levanda + tamsiai mėlyna
            </p>
            <div className="flex gap-3" data-id="element-516">
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-517">
                <div className="w-full rounded-lg border" style={{
                backgroundColor: '#FAFBFA',
                height: '72px',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-518" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-519">
                  #FAFBFA
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-520">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#EF9E54',
                height: '72px'
              }} data-id="element-521" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-522">
                  #EF9E54
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-523">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#C1548D',
                height: '72px'
              }} data-id="element-524" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-525">
                  #C1548D
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-526">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#7F8CB1',
                height: '72px'
              }} data-id="element-527" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-528">
                  #7F8CB1
                </span>
              </div>
              <div className="flex flex-col items-center gap-2 flex-1" data-id="element-529">
                <div className="w-full rounded-lg" style={{
                backgroundColor: '#262257',
                height: '72px'
              }} data-id="element-530" />
                <span className="text-xs font-mono" style={{
                color: '#888888'
              }} data-id="element-531">
                  #262257
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <div className="mt-12 pt-8 border-t" style={{
        borderColor: 'rgba(255,255,255,0.08)'
      }} data-id="element-532">
          <p className="text-sm" style={{
          color: '#555555'
        }} data-id="element-533">
            Pasirinkite paletę ir pritaikykite ją savo svetainei.
          </p>
        </div>
      </div>
    </div>;
}